import type { FC } from 'react';
import type { SvgIconProps } from '../IconBase';
import { IconBase } from '../IconBase';
import SvgIcon from 'assets/icons/Qr.svg?react';

export const QrIcon: FC<SvgIconProps> = (props) => {
    return (<IconBase icon={SvgIcon} {...props} />);
}